(() => {
  const popup = document.getElementById('GioventoNewsletterPopup');
  if (!popup) return;

  const cooldownKey = 'gioventoNewsletterPopupLastShownV1';
  const cooldownMs = 14 * 24 * 60 * 60 * 1000;
  const delayMs = 15000;
  const isPreview = new URLSearchParams(window.location.search).get('newsletter_popup') === 'preview';
  const closeButtons = popup.querySelectorAll('[data-newsletter-popup-close]');
  const firstField = popup.querySelector('input[type="text"], input[type="email"]');
  const successMessage = popup.querySelector('[data-newsletter-popup-success]');
  const footerSuccessMessage = document.querySelector('[data-footer-newsletter-success]');
  let lastFocusedElement;

  const setLastShown = () => {
    if (isPreview) return;
    try {
      window.localStorage.setItem(cooldownKey, String(Date.now()));
    } catch (error) {
      // The popup remains usable if local storage is unavailable.
    }
  };

  const isInCooldown = () => {
    try {
      const lastShown = Number(window.localStorage.getItem(cooldownKey));
      return Number.isFinite(lastShown) && Date.now() - lastShown < cooldownMs;
    } catch (error) {
      return false;
    }
  };

  const closePopup = () => {
    popup.hidden = true;
    popup.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('gio-newsletter-popup-open');
    if (lastFocusedElement) lastFocusedElement.focus();
  };

  const openPopup = () => {
    lastFocusedElement = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.body.classList.add('gio-newsletter-popup-open');
    setLastShown();
    window.setTimeout(() => firstField?.focus(), 100);
  };

  closeButtons.forEach((button) => button.addEventListener('click', closePopup));

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && !popup.hidden) closePopup();

    if (event.key !== 'Tab' || popup.hidden) return;
    const focusableElements = [...popup.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled])'
    )].filter((element) => element.getClientRects().length > 0);
    const firstFocusable = focusableElements[0];
    const lastFocusable = focusableElements[focusableElements.length - 1];
    if (!firstFocusable || !lastFocusable) return;

    if (event.shiftKey && document.activeElement === firstFocusable) {
      event.preventDefault();
      lastFocusable.focus();
    } else if (!event.shiftKey && document.activeElement === lastFocusable) {
      event.preventDefault();
      firstFocusable.focus();
    }
  });

  /* Shopify marks a successful customer form in the current URL. Remove that
     marker after showing the popup once so a browser refresh cannot reopen
     an outdated success state. */
  if (successMessage && !isPreview) {
    window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.hash}`);
  }

  if (footerSuccessMessage) {
    setLastShown();
    window.requestAnimationFrame(() => {
      footerSuccessMessage.scrollIntoView({ block: 'center', behavior: 'auto' });
      footerSuccessMessage.focus({ preventScroll: true });
      window.history.replaceState({}, document.title, window.location.pathname);
    });
    return;
  }

  /* Shopify marks a successful customer form in the current URL. Remove that
     marker after showing the popup once so a browser refresh cannot reopen
     an outdated success state. */
  if (successMessage && !isPreview) {
    window.history.replaceState({}, document.title, `${window.location.pathname}${window.location.hash}`);
  }

  if (isPreview || successMessage || popup.querySelector('.gio-newsletter-popup__error')) {
    openPopup();
    return;
  }

  if (!isInCooldown()) {
    window.setTimeout(openPopup, delayMs);
  }
})();
